import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "../../utils/baseQuery";
import { components } from "../../types/api";

// Vista de cliente: un único endpoint con todo lo que puede ver un CLIENT (el
// dinero solo como inversión del cliente, con margen; nunca el coste real ni
// márgenes). Home, campaña y subcampaña leen de la misma respuesta.
export type ClientPortalOverview =
  components["schemas"]["ClientPortalOverview"];
export type ClientPortalCompany = components["schemas"]["ClientPortalCompany"];
export type ClientPortalCampaign =
  components["schemas"]["ClientPortalCampaign"];
export type ClientPortalSubcampaign =
  components["schemas"]["ClientPortalSubcampaign"];
export type ClientPortalSeriesPoint =
  components["schemas"]["ClientPortalSeriesPoint"];
export type ClientPortalStatus = components["schemas"]["ClientPortalStatus"];
export type ClientKpi = components["schemas"]["ClientKpi"];
export type ClientPortalDetail = components["schemas"]["ClientPortalDetail"];
export type ClientPortalDetailSummary =
  components["schemas"]["ClientPortalDetailSummary"];
export type ClientPortalDetailDay =
  components["schemas"]["ClientPortalDetailDay"];
export type ClientPortalCreative =
  components["schemas"]["ClientPortalCreative"];
export type ClientPortalPlacement =
  components["schemas"]["ClientPortalPlacement"];
export type ClientPortalBreakdownRow =
  components["schemas"]["ClientPortalBreakdownRow"];
export type ClientPortalLocation =
  components["schemas"]["ClientPortalLocation"];
type ClientPortalOverviewResponse =
  components["schemas"]["ApiResponse_ClientPortalOverview_"];
type ClientPortalDetailResponse =
  components["schemas"]["ApiResponse_ClientPortalDetail_"];

export const clientPortalApi = createApi({
  reducerPath: "clientPortalApi",
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getClientOverview: builder.query<ClientPortalOverview | null, void>({
      query: () => `/client-portal/overview`,
      transformResponse: (response: ClientPortalOverviewResponse) =>
        response.data ?? null,
    }),
    // Detalle (anuncios, dónde se vio, audiencia...): se pide al abrir cada página.
    getClientSubcampaignDetail: builder.query<ClientPortalDetail | null, string>(
      {
        query: (subcampaignId) =>
          `/client-portal/subcampaigns/${subcampaignId}/detail`,
        transformResponse: (response: ClientPortalDetailResponse) =>
          response.data ?? null,
      }
    ),
    getClientCampaignDetail: builder.query<ClientPortalDetail | null, string>({
      query: (campaignId) => `/client-portal/campaigns/${campaignId}/detail`,
      transformResponse: (response: ClientPortalDetailResponse) =>
        response.data ?? null,
    }),
  }),
});

export const {
  useGetClientOverviewQuery,
  useGetClientSubcampaignDetailQuery,
  useGetClientCampaignDetailQuery,
} = clientPortalApi;
